import {
  BooleanType,
  PathType,
  SelectionType,
  StringType,
  ValueType
} from '@convergence/types';

export class InputValidationError extends Error {
  path: string[];
  constructor(message: string, path: string[]) {
    super(message);
    this.path = path;
  }
}

export function validateInput(input: ValueType) {
  const stack = [
    {
      value: input,
      path: [] as string[]
    }
  ];
  while (stack.length > 0) {
    const current = stack.pop()!;
    switch (current.value._type) {
      case 'object':
        for (const [key, val] of Object.entries(current.value._fields)) {
          stack.push({
            value: val,
            path: [...current.path, '_fields', key]
          });
        }
        break;
      case 'boolean':
        if (!validateBoolean(current.value, current.path)) {
          throw new Error('Invalid boolean');
        }
        break;
      case 'list':
        // current._value?.forEach((i: ValueType) => stack.push(i));
        current.value._value?.forEach((item, index) => {
          stack.push({
            value: item,
            path: [...current.path, '_value', index.toString()]
          });
        });
        break;
      case 'string':
        if (!validateString(current.value, current.path)) {
          throw new Error('Invalid string');
        }
        break;
      case 'selection':
        if (!validateSelection(current.value, current.path)) {
          throw new Error('Invalid selection');
        }
        break;
      case 'path':
        if (!validatePath(current.value, current.path)) {
          throw new Error('Invalid path');
        }
        break;
      default:
        throw new Error(`Invalid value ${JSON.stringify(current.value)}`);
    }
  }
}

function validateString(
  { _value, _optional, _validation }: StringType,
  path: string[]
) {
  if (!_value && !_optional) {
    throw new InputValidationError('String is invalid', path);
  }
  if (_value && _validation && !_value.match(_validation)) {
    throw new InputValidationError('String is invalid', path);
  }
  return true;
}

function validateSelection(s: SelectionType, path: string[]) {
  if (!s._value && !s._optional) {
    throw new InputValidationError('Selection is invalid', path);
    // return false
  }
  return true;
}

function validatePath(p: PathType, path: string[]) {
  console.log('validating path', p);
  if (!p._value && !p._optional) {
    throw new InputValidationError('Path is invalid', path);
  }
  if (p._value?.length === 0 && !p._optional) {
    // return false
    throw new InputValidationError('Path is invalid', path);
  }
  return true;
}

function validateBoolean(b: BooleanType, path: string[]) {
  if (b._value === null && !b._optional) {
    throw new InputValidationError('Boolean is invalid', path);
  }
  return true;
}
